module.exports = __webpack_public_path__ + "static/001-70ff03016dfdbc3a17b1634be7bf5e49.jpeg";